module.exports = __webpack_public_path__ + "img/product_4.998ebc52.jpg";